var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"21","height":"18","viewBox":"0 0 194 146","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M194 146H0V0H194V146Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M194 146H0V73H194V146Z","fill":"#DC143C"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }